import { Alert, Snackbar } from '@mui/material';
import React from 'react';

export default function Toast({ alertMessage, setAlertMessage, alertSeverity }: any) {
	return (
		<div>
			<Snackbar
				open={Boolean(alertMessage)}
				autoHideDuration={6000}
				onClose={() => setAlertMessage(null)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			>
				<Alert
					severity={alertSeverity}
					variant="filled"
					onClose={() => setAlertMessage(null)}
					sx={{ width: '100%' }}
				>
					{alertMessage}
				</Alert>
			</Snackbar>
		</div>
	);
}
